// import axios from "axios";
// import axios from "../../components/Axios/Axios";

import { DEFAULT_URL } from "../../components/api/API";
import { DELETE, GET, POST, PUT } from "../../components/axios/Axios";
import { employee } from "../../components/axios/endpoint";
import { getRequest } from "../../components/axios/request";
import { catchError } from "../../utils/Helper";
import { addQueryParams } from "../../utils/helpers";
import { EMPLOYEE } from "../Action";

export const employeeDetails = (data, callback) => {
  return (dispatch) => {
    POST(
      `${DEFAULT_URL}/employee`,
      data,
      {},
      (response) => {
        dispatch({
          type: EMPLOYEE.employee,
          payload: response.data,
        });
        callback(response.data);
      },
      (error) => {
        callback(catchError(error));
      }
    );
  };
};

export const getEmployeeDetails = async (query, signal) => {
  try {
    const response = await getRequest(employee.getEmployees, query, signal);
    return response?.data;
  } catch (error) {
    console.error("Error fetching employee:", error);
    throw error;
  }
};

export const getRoleOptions = (callback = () => {}) => {
  return (dispatch) => {
    GET(
      `${DEFAULT_URL}/role`,
      {},
      (response) => {
        dispatch({
          type: EMPLOYEE.getRoles,
          payload: response.data,
        });
        callback(response.data);
      },
      (error) => {
        callback(catchError(error));
      }
    );
  };
};

export const getReportingManagers = (callback = () => {}) => {
  return (dispatch) => {
    GET(
      `${DEFAULT_URL}/employeeName`,
      {},
      (response) => {
        dispatch({
          type: EMPLOYEE.getReportingManager,
          payload: response.data,
        });
        callback(response.data);
      },
      (error) => {
        callback(catchError(error));
      }
    );
  };
};

export const updateEmployeeDetails = (data, id, callback = () => {}) => {
  return (dispatch) => {
    PUT(
      `${DEFAULT_URL}/employee/${id}`,
      data,
      {},
      (response) => {
        dispatch({
          type: EMPLOYEE.updateEmployee,
          payload: response.data,
        });
        callback(response.data);
      },
      (error) => {
        callback(catchError(error));
      }
    );
  };
};

export const deleteEmployeeDetails = (id, callback = () => {}) => {
  return (dispatch) => {
    DELETE(`${DEFAULT_URL}/employee/${id}`, {}, (response) => {
      dispatch({
        type: EMPLOYEE.deleteEmployee,
        payload: response.data,
      });
      callback(response.data);
    });
  };
};

export const MenuItem = (callback = () => {}) => {
  return (dispatch) => {
    GET(
      `${DEFAULT_URL}/menu`,
      {},
      (response) => {
        dispatch({
          type: EMPLOYEE.menuItem,
          payload: response.data,
        });
        callback(response.data);
      },
      (error) => {
        callback(catchError(error));
      }
    );
  };
};
